

import { addLocale } from 'primereact/api';

const messages = {
    en: {
     
      close_form: "Close",
      new_firm: "New Firm",
      update_firm: "Update Firm",
      updaterec: "Update",
      firm_insert_successfully: "Firm insert successfully!",
      firm_update_successfully: "Firm update successfully!",
      dpr_update_successfully: "Department update successfully!",
      create_firm: "Create Firm",
      create_sub_firm: "Create Sub Firm",
      search_by_firm_name: "Search by firm name",
      search_by_name: "Search by name",
      firm_main_code: "Main Code",
      firm_main_code_l: "Firm Main Code",
      main_code: " Main Code",
      sub_code: "Sub Code",
      create_room_classrec: "Create Class",
      create_room_typerec: "Create Type",
      select_a_room_class: "Select a Room Class",
      select_a_room_type: "Select a Room Type",
      select_a_bed_type: "Select a Bed Type",
      select_a_department_holder: "Select a Department",
      select_a_agency: "Select a Agency",
      room_class_tab: "Room Class",
      room_type_tab: "Room Type",
      room_class_code: "Room Class Code",
      room_class_name: "Room Class Name",
      room_type_code: "Room Type Code",
      room_type_name: "Room Type Name ",
      room_bed_title: "Bed",
      room_bed_type_title: "Bed Type",
      room_min_pax_title: "Min Pax",
      room_max_pax_title: "Max Pax",
      room_chl_min_title: "Min Chl",
      room_chl_max_title: "Max Chl",
      room_total_title: "Total Room",
      room_baby_start_title: "Baby Start",
      room_baby_end_title: "Baby End",
      room_chl_start_title: " Chl Start",
      room_chl_end_title: "Chl End",
      //room type
      room_type_detail_title: "Room Type Detail",
      room_type_departments_title: "Room Type Departmants",
      room_type_property_title: "Room Type Properties",
      room_type_lang_title: "Other Lang",
      room_type_building_list: "Building List",
      room_list_title: "Rooms List",
      room_base_realtion: "Base Price Relation",

      room_person_factor_title: "Room Person Factor Definition",
      room_person_factor_dtl_title: "Room person Factor Detail",
      new_factor_btn: "New Factor",
      factor_title: "Factor",

      //dynamic Price
      dynamic_price_management: "Dynamic Price Management",
      dynamic_price_id_title: "Price Id",
      dynamic_price_desc_title: "Price Description",
      dynamic_price_new_btn: "New Price Grp",
      dynamic_price_group_title: "Dynamic Price Group Defination",
      dynamic_price_group_detail_btn: "New Price Detail",
      dynamic_price_group_code_title: "group Code",
      dynamic_price_group_percent_title: "Persent",
      dynamic_persent_conde_title: "percent Code",






      

      //contract
      cont_id_title: "Cont Id",
      cont_id_k_title: "S Cont Id",
      cont_type_title: "Cont Type",
      cont_type_k_title: "S Cont Type",
      cont_start_date_title: "Contract Start Date",
      cont_end_date_title: "Contract End Date",
      cont_hotel_sub_title: "Hotel Sub",
      cont_agency_main_title: "Agency Main",
      cont_agency_sub_title: "Agency Sub",
      sales_office_title: "Sales Office",
      price_title: "Price",
      cont_management_title: "Contract Management",
      cont_detail_title: "Contract Detail",
      cont_new_button: "New Contract",
      cont_group_title: "Contract Group",
      cont_grp_code_title: "Group Id",
      market_code_title: "Cont Id",
      market_title: "Market",
      select_market_holder: "Select a Market",
      cont_grp_select_holder: "Select Contract Group",
      cont_detail_tab: "Contract Detail",
      cont_rules_tab: "Rules",
      cont_season_tab: " Seasons & Prices",
      cont_reductions_tab: "Reductions",
      cont_guarantee_tab: "Guarantee",
      cont_special_con_tab: "Special Conditions",
      cont_offers_tab: "Offers",
      cont_pax_calcutate_tab: "Pax Calcutate",


       //Season
       sea_new_btn: "New Season",
       sea_Season_title: "Season Definition",
       sea_management_title: "Season Management",
       sea_id_title: "Season Id",
       sea_desc_title: "Season Description",
       start_date_title: "Start Date",
       end_date_title: "End Date",
       sea_new_per_btn: "New Period",
 
       //Period
       per_new_btn: "New Period",
       per_id_title: "Period Id",
       per_code_title: "Period Code",
       per_relaise_title: "Relaise",
       per_min_stay_title: "Min Stay",


       //Rules

       rules_management: "Rules Management",
       new_rule_grp_btn: "New Rule Group",
       new_rule_btn: "New Rule",
       new_premises_btn: "New Premises",
       new_result_btn: "New Result",
       rule_class_title: "Class",
       rule_class_name_title: "Rule Class",
       rule_type_title: "Type",
       rule_type_name_title: "Rule Type",
       rule_desc_title: "Description",
       rule_grp_id_title: "Grp Id",
       rule_grp_title: "Rule Group",
       rule_detail_title: "Rule Detail",
       rule_definition: "New Definition",
       rule_id_title: "Rule Id",
       premises_management_title: "Premises Rule Management",
       years_old_title: "Years Old >",
       result_management_title: "Result Rule Management",
       select_rule_result_hint: "Select Result Type",
       select_rule_class_hint: "Select Rule Class",
       select_rule_type_hint: "Select Rule Type",
       rule_persent_title: "Persent",
       when_title: "When",
       value_title: "Value",
       calcutate_title: "Calc",
       rule_ebo_title: "Early Booking Offer",
       rule_sso_title: "Senior Offer",
       rule_hmo_title: "Honey Moon Offer",
       rule_grp_title: "Group Offer",
       rule_lso_title: "Long Stay Offer",
       rule_person_title: "Person",
       rule_stay_day_title: "Stay Long >",
       rule_grp_person_title: "Person >",
       res_start_date_title: "Book Start Date",
       res_end_date_title: "Book End Date",
       stay_start_date_title: "Stay Start Date",
       stay_end_date_title: "Stay End Date",



           
      firm_sub_code: "Sub Code",
      firm_sub_name: "Sub Name",
      firm_code: "Firm Code",
      firm_name: "Firm Name",
      firm_type: "Firm Type",
      typerec: "Type",
      placerec: "Place",
      int_id: "int ID",
      integration_id_title: "Integration Id",
      currentPageReportTemplate:"Showing {first} to {last} of {totalRecords}",
      statusrec: "Status",
      detail: "Detail",
      create: "Create",
      update: "Update",
      activerec: "Active",
      inactiverec: "Inactive",
      definitions: "Definitions",
      managing_agency: "Managing Agency",
      managing_hotel: "Managing Hotel",
      managing_room_class: "Managing Room Class",
      managing_room_type: "Managing Room Type",
      managing_operator: "Managing Operator",
      firm_detail: "Firm Detail",
      agency_detail: "Agency Detail",
      operator_detail: "Operator Detail",
      sub_agency_detail: "Sub Agency Detail",
      sub_hotel_detail: "Sub Hotel Detail",
      main_department_tab: "Main Departments",
      sub_department_tab: "Sub Departments",
      main_department_code: "Department Code",
      main_department_name: "Department Name",
      sub_department_code: "Sub Department Code",
      sub_department_name: "Sub Department Name",
      rulesrec: "Rules",
      account_cart_tab: "Account Cart",
      bank_accounts_tab: "Bank Accounts",
      administrator: "Administrator",
      dashboard: "Dashboard",
      time_zone: "Time Zone",
      position: "Position",
      currency_title: "Currency",
      currency_code_title: "Code",
    },
    tr: {

      close_form: "Kapat",
      new_firm: "Yeni Firma",
      update_firm: "Firma Güncelle",
      updaterec: "Güncelle",
      firm_insert_successfully: "Firma Kaydedildi!",
      firm_update_successfully: "Firma Güncellendi!",
      dpr_update_successfully: "Departman Güncellendi!",
      create_firm: "Yeni Firma",
      create_sub_firm: "Yeni Şube",
      search_by_firm_name: "Firma Adında Arayın",
      search_by_name: "Adında Arayın",
      firm_main_code: "Ana Kodu",
      firm_main_code_l: "Firma Ana Kodu",
      main_code: "Ana Kod",
      sub_code: "Alt Kodu",
      create_room_classrec: "Yeni Class",
      create_room_typerec: "Yeni Type",
      select_a_room_class: "Oda Sınıfı Seçin",
      select_a_bed_type: "Yatak Tipi Seçin",
      select_a_room_type: "Oda Tipi Seçin",
      select_a_department_holder: "Departman Secin",
      select_a_agency: "Acenta Seçin",
      room_class_tab: "Oda Sınıfları",
      room_type_tab: "Oda Tipleri",
      room_class_code: "Oda Sınıf Kodu",
      room_class_name: "Oda Sınıf Adı",
      room_type_code: "Oda Tipi Kodu",
      room_type_name: "Oda Tipi Adı",
      room_bed_title: "Yatak",
      room_bed_type_title: "Yatak Tipi",
      room_min_pax_title: "Min Pax",
      room_max_pax_title: "Max Pax",
      room_chl_min_title: "Min Chl",
      room_chl_max_title: "Max Chl",
      room_total_title: "Toplam Oda",
      room_baby_start_title: "Bebek Başlangıç",
      room_baby_end_title: "Bebek Bitiş",
      room_chl_start_title: "Çocuk Başlangıç",
      room_chl_end_title: "Çocuk Bitiş",
      //room type
      room_type_detail_title: "Oda Tipi Detayı",
      room_type_departments_title: "Departmanlar",
      room_type_property_title: "Oda Tipi Özellikleri",
      room_type_lang_title: "Diğer Diller",
      room_type_building_list: "Binalar",
      room_list_title: "Oda Listesi",
      room_base_realtion: "Baz Fiyat Iliskisi",
      room_person_factor_title: "Oda Pax Carpan Tanimlari",
      room_person_factor_dtl_title: "Room person Factor Detail",
      new_factor_btn: "Yeni Carpan",
      factor_title: "Carpan",

      cont_id_title: "Cont Id",
      cont_id_k_title: "S Cont Id",
      cont_type_title: "Kontrat Tipi",
      cont_type_k_title: "S Cont Type",
      cont_start_date_title: "Contrat Başlangıç",
      cont_end_date_title: "Contat Bitiş",
      cont_hotel_sub_title: "Hotel Şubesi",
      cont_agency_main_title: "Merkez Acenta",
      cont_agency_sub_title: "Acenta Şubesi",
      sales_office_title: "Satis Departmanı",
      price_title: "Fiyatlar",
      cont_management_title: "Kontrat Yönetimi",
      cont_detail_title: "Kontrat Detayları",
      cont_new_button: "Yeni Kontrat",
      cont_group_title: "Kontrat Grubu",
      cont_grp_code_title: "Grup Id",
      cont_grp_select_holder: "Kontrat Grubu Seçin",
      market_code_title: "Mark Id",
      market_title: "Market",
      select_market_holder: "Market Seçin",
      cont_detail_tab: "Contrat Detayları",
      cont_rules_tab: "Kurallar",
      cont_season_tab: "Sezon & Fiyat",
      cont_reductions_tab: "İndirim & Eklemeler",
      cont_guarantee_tab: "Garantiler",
      cont_special_con_tab: "Özel Koşullar",
      cont_offers_tab: "Promosyonlar",
      cont_pax_calcutate_tab: "Pax Hesapları",

       //Season
       sea_new_btn: "Yeni Sezon",
       sea_Season_title: "Sezon Tanımları",
       sea_management_title: "Sezon Yönetimi",
       sea_id_title: "Sezon Id",
       sea_desc_title: "Sezon Açıklaması",
       start_date_title: "Başlangıç Tarihi",
       end_date_title: "Bitiş Tarihi",
       sea_new_per_btn: "Yeni Period",
 
       //Period
       per_new_btn: "Yeni Period",
       per_id_title: "Period Id",
       per_code_title: "Period Kodu",
       per_relaise_title: "Relaise",
       per_min_stay_title: "Min Konaklama",


        //Rules

        rules_management: "Kural Yönetimi",
        new_rule_grp_btn: "Yeni Kural Grup",
        new_rule_btn: "Yeni Kural",
        new_premises_btn: "Yeni Kriter",
        new_result_btn: "Yeni Sonuç",
        rule_class_title: "Sınıf",
        rule_class_name_title: "Kural Sınıfı",
        rule_type_title: "Tipi",
        rule_type_name_title: "Kural Tipi",
        rule_desc_title: "Açıklama",
        rule_grp_id_title: "Grp Id",
        rule_grp_title: "Kural Grubu",
        rule_detail_title: "Kural Detayı",
        rule_definition: "Yeni Tanım",
        rule_id_title: "Kural Id",
        premises_management_title: "Kural Kriteri Yönetimi",
        years_old_title: "Yaşından >",
        result_management_title: "Kural Sonuçları Yönetimi",
        select_rule_result_hint: "Sonuç Tipi Seçiniz",
        select_rule_class_hint: "Kural Sınıfı seçiniz",
        select_rule_type_hint: "Kural Tipi Seçiniz",
        rule_persent_title: "Yüzde",
        when_title: "Ne Zaman",
        value_title: "Değer",
        calcutate_title: "Hesap",
        rule_ebo_title: "Early Booking Offer",
        rule_sso_title: "Senior Offer",
        rule_hmo_title: "Honey Moon Offer",
        rule_grp_title: "Group Offer",
        rule_lso_title: "Long Stay Offer",
        rule_person_title: "Kişi",
        rule_stay_day_title: "Konaklama >",
        rule_grp_person_title: "Pax >",
        res_start_date_title: "Rezervasyon Başlangıç",
        res_end_date_title: "Rezervasyon Bitiş",
        stay_start_date_title: "Konaklama Başlangıç",
        stay_end_date_title: "Konaklama Bitiş",

          //dynamic Price
      dynamic_price_management: "Dinamik Fiyat Yonetimi",
      dynamic_price_id_title: "Grup Id",
      dynamic_price_desc_title: "Grup Aciklamasi",
      dynamic_price_new_btn: "Yeni Fiyat Grp",
      dynamic_price_group_title: "Dinamik Fiyat Group Tanim",
      dynamic_price_group_detail_btn: "Yeni Fiyat Detay",
      dynamic_price_group_code_title: "Grup Code",
      dynamic_price_group_percent_title: "Yuzde %",
      dynamic_persent_conde_title: "Yuzde Kodu",
        
 
      
      
      firm_sub_code: "Şube Kodu",
      firm_sub_name: "Sube Adı",
      firm_code: "Firma Kodu",
      firm_name: "Firma Adı",
      firm_type: "Firma Tipi",
      typerec: "Tip",
      placerec: "Bölge",
      int_id: "Ent ID",
      integration_id_title: "Integration Id",
      currentPageReportTemplate: "Toplam {totalRecords} kayıttan {first} ile {last} arası kayıtlar gösteriliyor",
      statusrec: "Durum",
      detail: "Detay",
      create: "Oluşturma",
      update: "Güncelleme",
      activerec: "Aktif",
      inactiverec: "Pasif",
      definitions: "Tanımlar",
      managing_agency: "Acenta Yönetimi",
      managing_hotel: "Hotel Yönetimi",
      managing_room_class: "Oda Sınıfları Yönetimi",
      managing_room_type: "Oda Tipi Yönetimi",
      managing_operator: "Operator Yönetimi",
      firm_detail: "Firma Detayları",
      agency_detail: "Acenta Detay",
      operator_detail: "Operator Detay",
      sub_agency_detail: "Alt Acenta Detay",
      sub_hotel_detail: "Hotel Şube",
      main_department_tab: "Ana Departman",
      sub_department_tab: "Alt Departman",
      main_department_code: "Departman Kodu",
      main_department_name: "Departman Adı",
      sub_department_code: "Alt Departman Kodu",
      sub_department_name: "Alt Departman Adı",
      rulesrec: "Kurallar",
      account_cart_tab: "Muhasebe Kartı",
      bank_accounts_tab: "Banka Hesapları",

      administrator: "Yönetim",
      dashboard: "Panel",
      time_zone: "Zaman Dilimi",
      position: "Konumu",
      currency_title: "Para Birimi",
      currency_code_title: "Kodu",

      firstDayOfWeek: 1,
      showMonthAfterYear: true,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Limpiar'
    },

    ru: {

      close_form: "Закрыть",
      new_firm: "Новая фирма",
      update_firm: "Обновить фирму",
      updaterec: "Обновить",
      firm_insert_successfully: "Фирма вставлена успешно!",
      firm_update_successfully: "фирма успешно обновлена!",
      dpr_update_successfully: "Подразделения успешно обновлена!",
      
      create_firm: "Новая фирма",
      create_sub_firm: "Создать субфирму",
      search_by_firm_name: "поиск по названию компании",
      search_by_name: "поиск по названию",
      firm_main_code: "главный код",
      firm_main_code_l: "Главный код компании",
      main_code: "главный код",
      sub_code: "Субкод",
      create_room_classrec: "Создать класс",
      create_room_typerec: "Создать тип",
      select_a_room_class: "Выберите класс номера",
      select_a_room_type: "Выберите тип номера",
      select_a_bed_type: "Выберите тип кровати",
      select_a_department_holder: "Select a Department",
      select_a_agency: "Select a Agency",
      room_class_tab: "Класс номера",
      room_type_tab: "Тип номера",
      room_class_code: "Код класса",
      room_class_name: "Название класса номера",
      room_type_code: "Код типа",
      room_type_name: "Название типа номера",
      room_bed_title: "Кровать",
      room_bed_type_title: "Тип кровати",
      room_min_pax_title: "Мин Пакс",
      room_max_pax_title: "Макс Пакс",
      room_chl_min_title: "Мин детей",
      room_chl_max_title: "Макс детка",
      room_total_title: "Общий номер",
      room_baby_start_title: "детка начни",
      room_baby_end_title: "детский конец",
      room_chl_start_title: "ребенок Начни",
      room_chl_end_title: "ребенок конец",
      //room type
      room_type_detail_title: "Room Type Detail",
      room_type_departments_title: "Room Type Departmants",
      room_type_property_title: "Room Type Properties",
      room_type_lang_title: "Other Lang",
      room_type_building_list: "Building List",
      room_list_title: "Rooms List",
      cont_new_button: "Новая",
      room_base_realtion: "Base Price Relation",
      room_person_factor_title: "Room Person Factor Definition",
      room_person_factor_dtl_title: "Room person Factor Detail",
      new_factor_btn: "New Factor",
      factor_title: "Factor",

      cont_id_title: "Cont Id",
      cont_id_k_title: "S Cont Id",
      cont_type_title: "Cont Type",
      cont_type_k_title: "S Cont Type",
      cont_start_date_title: "Contract Start Date",
      cont_end_date_title: "Contract End Date",
      cont_hotel_sub_title: "Гостиница",
      cont_agency_main_title: "Agency Main",
      cont_agency_sub_title: "субагентства",
      sales_office_title: "Sales Office",
      price_title: "Price",
      cont_management_title: "Contract Management",
      cont_detail_title: "Contract Detail",
      cont_group_title: "Kontrat Grubu",
      cont_grp_code_title: "Grup Id",
      cont_grp_select_holder: "Kontrat Grubu Seçin",
      market_code_title: "Mark Id",
      market_title: "Market",
      select_market_holder: "Select a Market",
      cont_detail_tab: "Contract Detail",
      cont_rules_tab: "Rules",
      cont_season_tab: " Seasons & Prices",
      cont_reductions_tab: "Reductions",
      cont_guarantee_tab: "Guarantee",
      cont_special_con_tab: "Special Conditions",
      cont_offers_tab: "Offers",
      cont_pax_calcutate_tab: "Pax Calcutate",


      //Season
      sea_new_btn: "New Season",
      sea_Season_title: "Season Definition",
      sea_management_title: "Season Management",
      sea_id_title: "Season Id",
      sea_desc_title: "Season Description",
      start_date_title: "Start Date",
      end_date_title: "End Date",
      sea_new_per_btn: "New Period",

      //Period
      per_new_btn: "New Period",
      per_id_title: "Period Id",
      per_code_title: "Period Code",
      per_relaise_title: "Relaise",
      per_min_stay_title: "Min Stay",


       //Rules

       rules_management: "Rules Management",
       new_rule_grp_btn: "New Rule Group",
       new_rule_btn: "New Rule",
       new_premises_btn: "New Premises",
       new_result_btn: "New Result",
       rule_class_title: "Class",
       rule_class_name_title: "Rule Class",
       rule_type_title: "Type",
       rule_type_name_title: "Rule Type",
       rule_desc_title: "Description",
       rule_grp_id_title: "Grp Id",
       rule_grp_title: "Rule Group",
       rule_detail_title: "Rule Detail",
       rule_definition: "New Definition",
       rule_id_title: "Rule Id",
       premises_management_title: "Premises Rule Management",
       years_old_title: "Years Old >",
       result_management_title: "Result Rule Management",
       select_rule_result_hint: "Select Result Type",
       select_rule_class_hint: "Select Rule Class",
       select_rule_type_hint: "Select Rule Class",
       rule_persent_title: "Persent",
       when_title: "When",
       value_title: "Value",
       calcutate_title: "Calc",
       rule_ebo_title: "Early Booking Offer",
       rule_sso_title: "Senior Offer",
       rule_hmo_title: "Honey Moon Offer",
       rule_grp_title: "Group Offer",
       rule_lso_title: "Long Stay Offer",
       rule_person_title: "Person",
       rule_stay_day_title: "Stay Long >",
       rule_grp_person_title: "Person >",
       res_start_date_title: "Book Start Date",
       res_end_date_title: "Book End Date",
       stay_start_date_title: "Stay Start Date",
       stay_end_date_title: "Stay End Date",

         //dynamic Price
      dynamic_price_management: "Dynamic Price Management",
      dynamic_price_id_title: "Price Id",
      dynamic_price_desc_title: "Price Description",
      dynamic_price_new_btn: "New Price Grp",
      dynamic_price_group_title: "Dynamic Price Group Defination",
      dynamic_price_group_detail_btn: "New Price Detail",
      dynamic_price_group_code_title: "group Code",
      dynamic_price_group_percent_title: "Persent",
      dynamic_persent_conde_title: "percent Code",





      firm_sub_code: "Код филиала",
      firm_sub_name: "Название филиала",
      firm_code: "Код фирма",
      firm_name: "Название фирма",
      firm_type: "тип фирма",
      typerec: "тип",
      placerec: "место",
      int_id: "ID инт",
      integration_id_title: "Integration Id",
      currentPageReportTemplate: "Показаны записи с {totalRecords} по {first} из {last} всего",
      statusrec: "статус",
      detail: "Деталь",
      create: "Создавать",
      update: "Обновлять",
      activerec: "Активный",
      inactiverec: "неактивный",
      definitions: "Определения",
      managing_agency: "Управляющее агентство",
      managing_hotel: "Управляющее Гостиница",
      managing_room_class: "Управляющее класса",
      managing_room_type: "Управляющее типа",
      managing_operator: "Управляющее оператор",
      firm_detail: "Сведения о фирме",
      agency_detail: "об агентстве",
      operator_detail: "об оператор",
      sub_agency_detail: "Подробности субагентства",
      sub_hotel_detail: "суб-отеля",
      main_department_tab: "Главные отделы",
      sub_department_tab: "Подразделения",
      main_department_code: "отделы Код",
      main_department_name: "Подразделения Код",
      sub_department_code: "отделы Код",
      sub_department_name: "Подразделения",
      rulesrec: "правила",
      account_cart_tab: "Корзина аккаунта",
      bank_accounts_tab: "Банковские счета",

      administrator: "Администратор",
      dashboard: "Панель приборов",
      time_zone: "Чвремя",
      position: "Position",
      currency_title: "Para Birimi",
      currency_code_title: "Kodu",
    
    },
  };

  addLocale('tr', {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Paz', 'Pzt', 'sal', 'çar', 'per', 'cum', 'cmt'],
    dayNamesMin: ['PA', 'PT', 'SA', 'ÇA', 'PE', 'CU', 'CT'],
    monthNames: ['Ocak', 'Subat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthNamesShort: ['oca', 'şub', 'mar', 'nis', 'may', 'haz', 'tem', 'ağu', 'eyl', 'eki', 'kas', 'ara'],
    today: 'Bugün',
    clear: 'Temizle'
});
  
  export default messages;